<div class=" body_container" style="position: relative" [ngClass]="currentEntity == 'Configurator' ? 'configuratorView' : ''">
  <div class="listHeader"  *ngIf="currentEntity != 'Configurator'">
    <h4>Storage List</h4>
    <button type="button"
            *ngIf="isUserGlobalAdmin"
            title="Create new storage"
            class="default-btn"
            style="float: right"
            [matMenuTriggerFor]="jobWizardType"
            #menuTrigger="matMenuTrigger">
      <span class="bi bi-plus-lg"></span>
      New Storage
    </button>
    <mat-menu #jobWizardType="matMenu" class="addJobMenu">
      <button type="button" mat-menu-item *ngFor="let type of cloudTypes" (click)="newStorage(type)">
        {{ type.name }}
      </button>
    </mat-menu>
  </div>
  <div>
    <table style="white-space: nowrap;" class="table " [ngClass]="currentEntity != 'Configurator' ? 'main-panel-table' : ''">
      <thead>
        <tr class="table-list-head">
          <th scope="col" resizable>#</th>
          <th scope="col" resizable>Name</th>
          <th scope="col" resizable>Deployment</th>
          <th scope="col" resizable>Type</th>
          <th scope="col" resizable>Infrastructure</th>
          <th scope="col" resizable>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" *ngFor="let dep of deployments | paginate: { itemsPerPage: 10, currentPage: p }; let i = index" style="cursor: pointer;">
          <td (click)="redirectTo(dep)" scope="row" *ngIf="p == 1">{{ i + 1 }}</td>
          <td (click)="redirectTo(dep)" scope="row" *ngIf="p != 1">{{ (p - 1) * 10 + (i + 1) }}</td>
          <td (click)="redirectTo(dep)" class="impListName">{{ dep.storageAccountName }}</td>
          <td (click)="redirectTo(dep)">{{ dep.name }}</td>
          <td (click)="redirectTo(dep)" >{{ dep.storageType }}</td>
          <td (click)="redirectTo(dep)" >{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  dep.cloud + " : VDI" : dep.cloud}}</td>
          <td>
            <button *ngIf="dep.toShowStorageActions && isUserGlobalAdmin" type="button" title="Check Status" class="default-btn me-3" (click)="checkDepStatus(dep)">
              Check Status
            </button>
            <button *ngIf="dep.toShowStorageActions && isUserGlobalAdmin" type="button" title="Edit" class="default-btn me-3" (click)="editStorage(dep)">
              Update
            </button>
            <button *ngIf="dep.toShowStorageActions && isUserGlobalAdmin" type="button" title="Delete" class="default-btn btn-danger" (click)="deleteStorage(dep)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination-controls *ngIf="deployments"
                         class="my-pagination ms-auto"
                         (pageChange)="p = $event">
    </pagination-controls>
    <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%;">No Deployment Available.</p>
  </div>

  <ngx-spinner bdColor="rgba(0,0,0,0)" name="storageList" size="default" color="var(--s-primary-color)" type="ball-spin" [fullScreen]="false"><p class="pleaseWait" > Please wait ... </p></ngx-spinner>
</div>
